import { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import NavButton from "./NavButton";
import TrendingPoster from "./TrendingPoster";
import MovieModal from "./MovieModal";

const API_URL = process.env.REACT_APP_API_URL || "https://api.fansfolder.com";

const TrendingSection = () => {
  const scrollRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedMovie, setSelectedMovie] = useState(null);
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkButtons();
  }, []);

  useEffect(() => {
    const fetchMovies = async () => {
      try {
        const res = await fetch(`${API_URL}/api/movies-public`);
        const data = await res.json();
        setMovies(data);
      } catch (err) {
        console.error("Failed to load movies:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchMovies();
  }, []);

  const checkButtons = () => {
    const el = scrollRef.current;
    if (!el) return;
    setShowLeft(el.scrollLeft > 0);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir * 220, behavior: "smooth" });
    }
  };

  return (
    <Section>
      <Title>Trending Now</Title>
      <SwiperContainer>
        <NavButton direction="left" visible={showLeft} onClick={() => scroll(-1)} />
        <ScrollRow ref={scrollRef} onScroll={checkButtons}>
          {loading
            ? Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} />
              ))
            : movies.map((movie, i) => (
                <div
                  key={movie._id}
                  onClick={() => {
                    setSelectedMovie(movie);
                    setShowModal(true);
                  }}
                >
                  <TrendingPoster
                    rank={i + 1}
                    posterUrl={movie.posterUrl}
                    onClick={() => {
                      setSelectedMovie(movie);
                      setShowModal(true);
                    }}
                  />
                </div>
              ))}
        </ScrollRow>
        <NavButton direction="right" visible={showRight} onClick={() => scroll(1)} />
      </SwiperContainer>

      {showModal && (
        <MovieModal
  titleSvg={selectedMovie?.titleSvg || ""}
  imageUrl={selectedMovie?.imageUrl || ""}
  description={selectedMovie?.description || ""}
  tags={selectedMovie?.tags || []}
  buyUrl={selectedMovie?.buyUrl || ""}  // only prop you need
  onClose={() => {
    setShowModal(false);
    setSelectedMovie(null);
  }}
/>
      )}
    </Section>
  );
};

export default TrendingSection;

// --- Styles ---
const Section = styled.section`
  padding: 0;
  background: #000;
  color: #fff;

  @media (max-width: 568px) {
    margin-top: -110px;
  }
`;

const Title = styled.h2`
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 30px;
  padding: 0 80px;
  text-align: left;

  @media (max-width: 868px) {
    font-size: 26px;
    padding: 0 35px;
  }

  @media (max-width: 568px) {
    font-size: 22px;
    padding: 0;
  }
`;

const SwiperContainer = styled.div`
  position: relative;
  padding: 0 80px;

  @media (max-width: 868px) {
    padding: 0 35px;
  }

  @media (max-width: 568px) {
    padding: 0;
  }
`;

const ScrollRow = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  gap: 44px;
  padding-bottom: 10px;
  min-height: 280px;

  & > div:first-child {
    margin-left: 20px;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 968px) {
    gap: 20px;
    min-height: 185px;
  }
`;

const Skeleton = styled.div`
  width: 200px;
  height: 280px;
  background: #1a1a1a;
  border-radius: 6px;
`;
